import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import LinhaForm from '../components/linha/LinhaForm';

const LinhaEditar: React.FC = () => {
  return (
    <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography 
          variant="h4" 
          component="h1" 
          gutterBottom 
          sx={{ 
            fontWeight: 'bold',
            fontFamily: 'Arial, sans-serif',
            fontSize: '2.125rem',
            lineHeight: 1.235
          }}
        >
          Editar Linha
        </Typography>
      </Box>
      <LinhaForm isEdit={true} />
    </Container>
  );
};

export default LinhaEditar;
